var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: _vm.paramsData.id ? _vm.$t("editEmail") : _vm.$t("addEmail"),
            visible: _vm.dialogShow,
            modal: false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData("ruleForm")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                model: _vm.paramsData,
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  key: "template_name",
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "template_name",
                    label: _vm.$t("templateName")
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "operationFrame-entity",
                    attrs: { placeholder: _vm.$t("pleaseInput") },
                    model: {
                      value: _vm.paramsData.template_name,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "template_name", $$v)
                      },
                      expression: "paramsData.template_name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addDomain }
                    },
                    [_vm._v(_vm._s(_vm.$t("addItem")))]
                  )
                ],
                1
              ),
              _vm._l(_vm.paramsData.reward, function(domain, index) {
                return _c(
                  "div",
                  {
                    key: index + "r",
                    staticClass: "lodingItemT",
                    staticStyle: { display: "flex" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "lodingItem-operationFrame flex" },
                      [
                        _c("el-switch", {
                          staticStyle: {
                            "margin-right": "10px",
                            "min-width": "120px"
                          },
                          attrs: {
                            "active-color": "#13ce66",
                            "inactive-color": "#ff4949",
                            "active-text": _vm.$t("permanent"),
                            "inactive-text": _vm.$t("valid")
                          },
                          model: {
                            value: domain.ispermanent,
                            callback: function($$v) {
                              _vm.$set(domain, "ispermanent", $$v)
                            },
                            expression: "domain.ispermanent"
                          }
                        }),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-bottom": "0px" },
                            attrs: {
                              prop: "reward." + index + ".type_id",
                              rules: domain.custom_input
                                ? []
                                : _vm.rules.item_id
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { "margin-right": "10px" },
                                attrs: {
                                  filterable: "",
                                  clearable: "",
                                  placeholder: _vm.$t("item"),
                                  disabled: !!domain.custom_input
                                },
                                model: {
                                  value: domain.type_id,
                                  callback: function($$v) {
                                    _vm.$set(domain, "type_id", $$v)
                                  },
                                  expression: "domain.type_id"
                                }
                              },
                              _vm._l(_vm.articleList, function(items, indexs) {
                                return _c("el-option", {
                                  key: indexs,
                                  attrs: { label: items.kind, value: items.id }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-bottom": "0px" },
                            attrs: {
                              prop: "reward." + index + ".custom_input",
                              rules: domain.type_id ? [] : _vm.rules.item_id
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { "margin-right": "10px" },
                              attrs: {
                                clearable: "",
                                placeholder: _vm.$t("customItemIdPlaceholder"),
                                type: "number",
                                disabled: !!domain.type_id
                              },
                              model: {
                                value: domain.custom_input,
                                callback: function($$v) {
                                  _vm.$set(domain, "custom_input", $$v)
                                },
                                expression: "domain.custom_input"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-bottom": "0px" },
                            attrs: {
                              prop: "reward." + index + ".expire",
                              rules: domain.ispermanent
                                ? null
                                : _vm.rules.expire_time
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: {
                                width: "200px",
                                "margin-right": "10px"
                              },
                              attrs: {
                                "popper-class": "no-at-theMoment",
                                disabled: domain.ispermanent,
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                type: "datetime",
                                placeholder: _vm.$t("date")
                              },
                              model: {
                                value: domain.expire,
                                callback: function($$v) {
                                  _vm.$set(domain, "expire", $$v)
                                },
                                expression: "domain.expire"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-bottom": "0px" },
                            attrs: {
                              prop: "reward." + index + ".num",
                              rules: _vm.rules.item_num
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "number",
                                placeholder: _vm.$t("quantity")
                              },
                              model: {
                                value: domain.num,
                                callback: function($$v) {
                                  _vm.$set(domain, "num", _vm._n($$v))
                                },
                                expression: "domain.num"
                              }
                            })
                          ],
                          1
                        ),
                        _c("el-button", {
                          staticStyle: { "margin-left": "10px" },
                          attrs: {
                            size: "mini",
                            type: "danger",
                            circle: "",
                            icon: "el-icon-delete"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.removeDomain(domain)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              }),
              _c(
                "div",
                { staticClass: "flex", staticStyle: { width: "100%" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem ",
                      staticStyle: { width: "13%" },
                      attrs: { prop: "default_content" }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "small",
                            disabled: _vm.paramsData.template_type == 1
                          },
                          on: { click: _vm.addContent }
                        },
                        [_vm._v(_vm._s(_vm.$t("addContent")) + " ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem ",
                      staticStyle: { width: "40%", "margin-right": "40px" },
                      attrs: {
                        label: _vm.$t("isTemplate"),
                        "label-width": "100px"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "flex-1",
                          attrs: { placeholder: _vm.$t("pleaseChoose") },
                          on: { change: _vm.isTemplateChange },
                          model: {
                            value: _vm.isTemplate,
                            callback: function($$v) {
                              _vm.isTemplate = $$v
                            },
                            expression: "isTemplate"
                          }
                        },
                        _vm._l(_vm.moduleList, function(item) {
                          return _c("el-option", {
                            key: item.label,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm.isTemplate == 1
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "lodingItem ",
                          staticStyle: { width: "40%" },
                          attrs: {
                            label: _vm.$t("templateType"),
                            "label-width": "100px"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "flex-1",
                              attrs: { placeholder: _vm.$t("pleaseChoose") },
                              on: { change: _vm.templateTypeChange },
                              model: {
                                value: _vm.paramsData.template_type,
                                callback: function($$v) {
                                  _vm.$set(_vm.paramsData, "template_type", $$v)
                                },
                                expression: "paramsData.template_type"
                              }
                            },
                            _vm._l(_vm.templateList, function(item) {
                              return _c("el-option", {
                                key: item.label,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._l(_vm.paramsData.default_content, function(domain, index) {
                return _c(
                  "div",
                  { key: index + "k", staticClass: "content_ValClass" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "lodingItem-operationFrame flex",
                        staticStyle: { "margin-bottom": "20px" }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "lodingItem contentValitem",
                            attrs: {
                              prop: "default_content." + index + ".title",
                              rules: _vm.rules.title,
                              label: _vm.$t("title"),
                              "label-width": "60px"
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "operationFrame-entity",
                              attrs: {
                                disabled: _vm.paramsData.template_type != 0,
                                clearable: "",
                                placeholder: _vm.$t("pleaseInputTitle")
                              },
                              model: {
                                value: domain.title,
                                callback: function($$v) {
                                  _vm.$set(domain, "title", $$v)
                                },
                                expression: "domain.title "
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "lodingItem contentValitem",
                            attrs: {
                              prop: "default_content." + index + ".language",
                              rules: _vm.rules.language,
                              label: _vm.$t("language"),
                              "label-width": "60px"
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "flex-1",
                                attrs: {
                                  disabled: _vm.paramsData.template_type != 0,
                                  clearable: "",
                                  filterable: "",
                                  placeholder: _vm.$t("pleaseChoose")
                                },
                                model: {
                                  value: domain.language,
                                  callback: function($$v) {
                                    _vm.$set(domain, "language", $$v)
                                  },
                                  expression: "domain.language "
                                }
                              },
                              _vm._l(_vm.langList, function(item) {
                                return _c("el-option", {
                                  key: item.label,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm.paramsData.template_type != 1
                          ? _c("el-button", {
                              staticStyle: { margin: "0 0 16px 10px" },
                              attrs: {
                                size: "mini",
                                type: "danger",
                                circle: "",
                                icon: "el-icon-delete"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.removeContent(domain)
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "flex first_box lodingItem-title",
                        staticStyle: {
                          "margin-bottom": "20px",
                          width: "100%",
                          "align-items": "center"
                        }
                      },
                      [
                        _vm._v(_vm._s(_vm.$t("emailContent")) + ": "),
                        _vm.paramsData.template_type == 0
                          ? _c(
                              "div",
                              {
                                staticClass: "flex",
                                staticStyle: { "padding-left": "20px" }
                              },
                              _vm._l(_vm.tagList, function(items, indexs) {
                                return _c(
                                  "div",
                                  {
                                    key: indexs,
                                    staticClass: "addtag",
                                    on: {
                                      click: function($event) {
                                        return _vm.addtag(items.content, index)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(items.name))]
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          prop: "default_content." + index + ".content",
                          rules: _vm.rules.content
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            autosize: { minRows: 2, maxRows: 12 },
                            disabled: _vm.paramsData.template_type != 0,
                            placeholder: _vm.$t("pleaseInputContent")
                          },
                          model: {
                            value: domain.content,
                            callback: function($$v) {
                              _vm.$set(domain, "content", $$v)
                            },
                            expression: "domain.content "
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      return _vm.hiad()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.clearData()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("reset")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.dataFormSubmit("ruleForm")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("confirm")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }